export const CHANNEL_EMAIL = 1
export const CHANNEL_PHONE = 2
